/**
 * @fileoverview GET handler for the "/apps/:app_id/sdk_authentication_analytics" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdSdkAuthenticationAnalytics } from "./constants";
import type { AppsAppIdSdkAuthenticationAnalyticsResult } from "./types";

export const getAppsAppIdSdkAuthenticationAnalytics = reactQueryFetcherAdapter(
  appsAppIdSdkAuthenticationAnalytics,
  (
    signal: AbortSignal,
    appId: string,
    start: number,
    end: number
  ): Promise<AppsAppIdSdkAuthenticationAnalyticsResult> => {
    return fetch(`/apps/${appId}/sdk_authentication_analytics`, "GET", { start, end }, { signal });
  }
);
